WL.registerComponent('package', {    
},   
{
    init:function(){
        this.originalParent = this.object.parent;
    },
    start: function () 
    {        
        this.isHeld = false;
    },
    reset:function(){
        this.object.parent = this.originalParent;
        this.isHeld = false;    
    },
    // spawn: function () {
    //     this.isInPool = false;
    //     const rad = Math.random()*Math.PI*2;
    //     this.object.rotateAxisAngleDeg([0, 1, 0], Math.random()*360);
    //     this.object.setTranslationLocal([Math.sin(rad)*.5, this.animalType === 0 ? POLARBEAR_Y : PENGUIN_Y, Math.cos(rad)*.5]);
        
    //     return this;
    // },
    // kill: function () {
    //     this.isInPool = true;
    // },
    update: function (dt) {
        //if (this.isHeld) return;
    },
});
